import moment from "moment";
import { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import useIndexDBValue from "src/app/hook/useIndexDBValue";
import { seachUserMetadata } from "src/app/modules/auth/core/_requests";
import { SelectEditor, useSelectEditorManager } from "src/app/modules/component/select-editor";
import { TimeEditor } from "src/app/modules/component/time-editor/TimeEditor";
import { useTimeEditorManager } from "src/app/modules/component/time-editor/useTimeEditorManager";
import { hasAuthority, KEY_AUTHORITIES } from "src/app/modules/utils/Permission";
import ButtonInPhieu from "../../../component/button-in-phieu";
import { MAP_EXPORT_PATH } from "../../../component/button-in-phieu/constant";
import { ConfirmDialog } from "../../../component/ConfirmDialog";
import ContextMenu from "../../../component/ContextMenuV3";
import DanhSachPhieu from "../../../component/DanhSachPhieu";
import LabelRequired from "../../../component/LabelRequired";
import { TableCustom } from "../../../component/table/table-custom/TableCustom";
import { IDanhSachDanhMuc } from "../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel";
import { CODE, KEY, KEY_DS_DANH_MUC_TIEP_DON, MESSAGE, ORDER_TYPE_ID, PATH_NAME, RESPONSE_MESSAGE } from "../../../utils/Constant";
import { getErrorMessage } from "../../../utils/FormatUtils";
import { getIndexedDBItem } from "../../../utils/IndexedDB";
import { congKhamColumn } from "../../columns/tab-cong-kham/ColumnTabCongKham";
import { CODE_CONTEXT_TAB_XET_NGHIEM, listContextDichVuCongKham } from "../../constants/ContextConstants";
import { PhanHeTiepDonContext } from "../../contexts/PhanHeTiepDonContext";
import "../../PhanHeKhamBenh.scss";
import { getDSCongKhamDaChiDinh, getServiceListByType, updateOrderGroupFields } from "../../services/ChiDinhDVService";
import { cancelCongKham, changeCongKham } from "../../services/KhamBenhService";
import { inPhieuChiDinhCongKham, inPhieuChuyenPK } from "../../services/PrintExportService";

export type KhamBenh = {
    thongTinKhamBenh?: any;
    setThongTinKhamBenh: ((data: any) => void) | undefined;
};

export const TabCongKham = () => {
    const { pathname } = useLocation();
    const { benhNhanInfo } = useContext(PhanHeTiepDonContext);
    let { visit, isConclusion, orderId } = benhNhanInfo?.thongTinKhamBenh || {};
    const [dsPhieu, setDsPhieu] = useState<any[]>([]);
    const [selectedPhieu, setSelectedPhieu] = useState<any>([]);
    const [selectedIndex, setSelectedIndex] = useState<any>(0);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const contextRef = useRef<HTMLDivElement | null>(null);
    const [contextMenu, setContextMenu] = useState<null | {
        x: number;
        y: number;
    }>(null);
    const [dsXetNghiemDetail, setDsXetNghiemDetail] = useState<any[]>([]);
    const [listICD10, setListICD10] = useState<any>([]);
    const encounterDiagnosis = benhNhanInfo?.thongTinKhamBenh?.encounterDiagnosis;
    const [keyOpenPhieuIn, setKeyOpenPhieuIn] = useState<string>("");
    const [rowSeclectedByContextMenu, setRowSeclectedByContextMenu] = useState<any>();

    const { value: danhSachDanhMuc } = useIndexDBValue<IDanhSachDanhMuc>({
        key: KEY_DS_DANH_MUC_TIEP_DON,
    });

    const allowEdit = !isConclusion && hasAuthority(KEY_AUTHORITIES.UPDATE_FIELDS.PHIEU_CHI_DINH);

    const indicationTimeManager = useTimeEditorManager({
        name: "indicationTime",
        values: selectedPhieu,
        updateFields: updateOrderGroupFields,
        onUpdateSuccess: (updatedData) => {
            if (!updatedData?.indicationTime) return;
            // Cập nhật selectedPhieu với data mới
            setSelectedPhieu((prev: any) => ({
                ...prev,
                indicationTime: updatedData.indicationTime
            }));

            // Cập nhật trong danh sách phiếu
            setDsPhieu((prevList: any[]) =>
                prevList.map((phieu: any) =>
                    phieu.id === selectedPhieu?.id
                        ? { ...phieu, indicationTime: updatedData.indicationTime, date: moment(updatedData.indicationTime).format("DD/MM/YYYY") }
                        : phieu
                )
            );
        }
    });

    const indicationPersonSelectManager = useSelectEditorManager({
        name: "indicationPerson",
        idFieldName: "id",
        values: selectedPhieu,
        updateFields: updateOrderGroupFields,
        buildPayload: (option) => ({
            indicationPerson: option?.fullName,
            indicationTime: selectedPhieu?.indicationTime
        }),
        onUpdateSuccess: (updatedData) => {
            if (!updatedData?.indicationPerson) return;
            // Cập nhật selectedPhieu với data mới
            setSelectedPhieu((prev: any) => ({
                ...prev,
                indicationPerson: updatedData.indicationPerson
            }));

            // Cập nhật trong danh sách phiếu
            setDsPhieu((prevList: any[]) =>
                prevList.map((phieu: any) =>
                    phieu.id === selectedPhieu?.id
                        ? { ...phieu, indicationPerson: updatedData.indicationPerson }
                        : phieu
                )
            );
        },
        enableConfirmWithReason: false, // Không dùng confirm with reason cho trường hình thức
    });

    const requestDeptNameSelectManager = useSelectEditorManager({
        name: "requestDeptName",
        idFieldName: "id",
        values: selectedPhieu,
        updateFields: updateOrderGroupFields,
        buildPayload: (option) => ({
            requestDeptCode: option?.code,
            requestDeptName: option?.name,
            indicationTime: selectedPhieu?.indicationTime
        }),
        onUpdateSuccess: (updatedData) => {
            if (!updatedData?.requestDeptName) return;
            // Cập nhật selectedPhieu với data mới
            setSelectedPhieu((prev: any) => ({
                ...prev,
                requestDeptName: updatedData.requestDeptName
            }));

            // Cập nhật trong danh sách phiếu
            setDsPhieu((prevList: any[]) =>
                prevList.map((phieu: any) =>
                    phieu.id === selectedPhieu?.id
                        ? { ...phieu, requestDeptName: updatedData.requestDeptName }
                        : phieu
                )
            );
        },
        enableConfirmWithReason: false,
    });

    const handleContextMenu = (e: any, row: any) => {
        e.preventDefault();
        setRowSeclectedByContextMenu(row?.original);
        setContextMenu({ x: e.clientX, y: e.clientY });
    };

    const handleClickOptionContextMenu = (value: any) => {
        const menuActions = {
            [CODE_CONTEXT_TAB_XET_NGHIEM.HUY_CONG_KHAM]: () => handleHuyCongKham(rowSeclectedByContextMenu),
        };
        menuActions[value?.code]?.();
        setContextMenu(null);
    };

    const handleHuyCongKham = async (row: any) => {
        try {
            const { data } = await cancelCongKham({
                orderId: row?.id
            });
            if (data?.code === CODE.SUCCESS) {
                toast.success("Hủy công khám thành công");
                updataData();
            } else {
                let errorMessage = getErrorMessage(data);
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error(error);
            toast.error(RESPONSE_MESSAGE.ERROR);
        }
    };

    const handleSelectPhieu = async (dataPhieu: any) => {
        try {
            setSelectedPhieu(dataPhieu);
            setSelectedIndex(dataPhieu?.index);
            let { data } = await getDSCongKhamDaChiDinh({
                orderGroupId: dataPhieu?.id,
                type: ORDER_TYPE_ID.CONG_KHAM
            });
            if (CODE.SUCCESS === data?.code) {
                setDsXetNghiemDetail(data?.data || []);
            } else {
                setDsPhieu([]);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleYesClick = () => {
        setOpenConfirmDialog(false);
        toast.success(MESSAGE.SUCCESS.XOA_PHIEU)
    };

    const updataData = async () => {
        try {
            let { data } = await getServiceListByType({
                visitId: visit?.id,
                type: ORDER_TYPE_ID.CONG_KHAM
            })
            let dsPhieuConverted = data?.data?.map((item: any, index: number) => {
                return {
                    ...item,
                    index,
                    date: moment(item?.indicationTime).format("DD/MM/YYYY"),
                }
            });
            setDsPhieu(dsPhieuConverted || []);
            if (dsPhieuConverted?.[selectedIndex]) {
                handleSelectPhieu(dsPhieuConverted?.[selectedIndex]);
            } else {
                setSelectedPhieu(null);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleChangeCongKham = async (orderId: string, termId: string) => {
        try {
            let { data } = await changeCongKham(orderId, termId);
            if (CODE.SUCCESS === data?.code) {
                toast.success(RESPONSE_MESSAGE.SUCCESS);
                updataData();
            } else {
               let errorMessage = data?.data?.[0]?.errorMessage || RESPONSE_MESSAGE.ERROR;
                toast.error(errorMessage);
            }
        } catch (error) {
            console.error(error);
            toast.error(RESPONSE_MESSAGE.ERROR);
        }
    };
    
    const handleGetListICD10 = async () => {
        try {
            let res: IDanhSachDanhMuc = await getIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON);
            setListICD10(res?.listICD10 || []);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        setSelectedIndex(0);
    }, [orderId]);

    useEffect(() => {
       if (orderId) {
           updataData();
       }
    }, [benhNhanInfo?.shouldUpdate, orderId]);

    useEffect(() => {
        handleGetListICD10();
    }, []);

    const handlePressKeyShortcuts = (e: any) => {
        switch (e.key) {
            case KEY.F1:
                e.preventDefault();
                setKeyOpenPhieuIn("F1");
                break;
            case KEY.F2:
                e.preventDefault();
                //Hàm của nút In phiếu khám gọi ở đây
                break;
            default:
                return;
        }
    };
  
    useEffect(() => {
      window.addEventListener("keydown", handlePressKeyShortcuts);
      return () => {
        window.removeEventListener("keydown", handlePressKeyShortcuts);
      };
    }, []);

    return (
        <Row className="spaces h-calc-vh-364">
            <div>
                <div className="pt-4 bg-white">
                    <Row className="mx-0">
                        <Col xs={4} className="d-flex align-items-center mb-3">
                            <LabelRequired label="Mã phiếu" className="min-w-100px" />
                            <span className="fw-light text-truncate">{selectedPhieu?.code || "..."}</span>
                        </Col>
                        <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Ngày y lệnh" className="min-w-100px" />
                            <TimeEditor
                                name="indicationTime"
                                values={selectedPhieu}
                                isEditingTime={indicationTimeManager.isEditingTime}
                                editedTime={indicationTimeManager.editedTime}
                                showValidationConfirm={indicationTimeManager.showValidationConfirm}
                                validationMessage={indicationTimeManager.validationMessage}
                                onEdit={indicationTimeManager.handleEditTime}
                                onCancel={indicationTimeManager.handleCancelEdit}
                                onSave={indicationTimeManager.handleSaveTime}
                                onConfirmValidation={indicationTimeManager.handleConfirmValidation}
                                onCancelValidation={indicationTimeManager.handleCancelValidation}
                                onTimeChange={indicationTimeManager.setEditedTime}
                                allowEdit={allowEdit}
                            />
                        </Col>
                        <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Người chỉ định" className="min-w-100px" />
                            <SelectEditor
                                name="indicationPerson"
                                values={{
                                    indicationPerson: selectedPhieu?.indicationPerson
                                }}
                                options={[]}
                                searchFunction={seachUserMetadata}
                                searchObject={{ position: 1 }}
                                urlData="data.content"
                                getOptionLabel={(opt) => opt?.fullName || ""}
                                inline={true}
                                menuPlacement="top"
                                isEditingSelect={indicationPersonSelectManager.isEditingSelect}
                                editedValue={indicationPersonSelectManager.editedValue}
                                showValidationConfirm={indicationPersonSelectManager.showValidationConfirm}
                                showConfirmWithReason={indicationPersonSelectManager.showConfirmWithReason}
                                validationMessage={indicationPersonSelectManager.validationMessage}
                                onEdit={indicationPersonSelectManager.handleEditSelect}
                                onCancel={indicationPersonSelectManager.handleCancelEdit}
                                onSave={indicationPersonSelectManager.handleSaveSelect}
                                onConfirmValidation={indicationPersonSelectManager.handleConfirmValidation}
                                onCancelValidation={indicationPersonSelectManager.handleCancelValidation}
                                onConfirmWithReason={indicationPersonSelectManager.handleConfirmWithReason}
                                onCancelWithReason={indicationPersonSelectManager.handleCancelWithReason}
                                onValueChange={indicationPersonSelectManager.setEditedValue}
                                allowEdit={allowEdit}
                            />                      
                        </Col>
                        <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Nơi chỉ định" className="min-w-100px" />
                            <SelectEditor
                                name="requestDeptName"
                                values={{
                                    requestDeptName: selectedPhieu?.requestDeptName
                                }}
                                options={danhSachDanhMuc?.listPhongKham || []}
                                inline={true}
                                menuPlacement="top"
                                isEditingSelect={requestDeptNameSelectManager.isEditingSelect}
                                editedValue={requestDeptNameSelectManager.editedValue}
                                showValidationConfirm={requestDeptNameSelectManager.showValidationConfirm}
                                showConfirmWithReason={requestDeptNameSelectManager.showConfirmWithReason}
                                validationMessage={requestDeptNameSelectManager.validationMessage}
                                onEdit={requestDeptNameSelectManager.handleEditSelect}
                                onCancel={requestDeptNameSelectManager.handleCancelEdit}
                                onSave={requestDeptNameSelectManager.handleSaveSelect}
                                onConfirmValidation={requestDeptNameSelectManager.handleConfirmValidation}
                                onCancelValidation={requestDeptNameSelectManager.handleCancelValidation}
                                onConfirmWithReason={requestDeptNameSelectManager.handleConfirmWithReason}
                                onCancelWithReason={requestDeptNameSelectManager.handleCancelWithReason}
                                onValueChange={requestDeptNameSelectManager.setEditedValue}
                                allowEdit={allowEdit}
                            />
                        </Col>
                        <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Trạng thái" className="min-w-100px" />
                            <span className="fw-light text-truncate">{dsXetNghiemDetail?.[0]?.currStatusName || "..."}</span>
                        </Col>
                        <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Nơi thực hiện" className="min-w-100px" />
                            <span className="fw-light text-truncate">{selectedPhieu?.fulfillDeptName || "..."}</span>
                        </Col>
                        <Col xs={12} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Chẩn đoán" className="min-w-100px" />
                            <span className="fw-light text-truncate">
                                {(isConclusion && encounterDiagnosis?.icdXPrimary)
                                    ? listICD10?.find((item: any) => item?.code === encounterDiagnosis?.icdXPrimary)?.name
                                    : "..."}
                            </span>
                        </Col>
                    </Row>
                </div>

                <div className="bg-white pt-2 mb-2">
                    <DanhSachPhieu
                        className="mb-2"
                        handleSelectRowData={handleSelectPhieu}
                        dsPhieu={dsPhieu as []} 
                        selectedIndex={selectedIndex}
                    />

                    <div className="tableLichSu border">
                        <TableCustom<any>
                            className={`spaces h-calc-vh-${PATH_NAME.KHAM_BENH === pathname ? "297" : "335"}`}
                            columns={congKhamColumn}
                            data={dsXetNghiemDetail || []}
                            tableOptions={{
                                handleChangeCongKham
                            }}
                            handleContextMenu={handleContextMenu}
                        />

                        {contextMenu && (
                            <div ref={contextRef}>
                                <ContextMenu
                                    handleClickOptionContextMenu={handleClickOptionContextMenu}
                                    handleCloseMenu={() => setContextMenu(null)}
                                    data={listContextDichVuCongKham}
                                    target={contextMenu}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className="d-flex justify-content-start spaces pb-5 pl-10 gap-8 bg-white position-sticky bottom-0">
                    {selectedPhieu?.id && (
                        <ButtonInPhieu
                            label="Phiếu chỉ định (F1)"
                            fetchExport={inPhieuChiDinhCongKham}
                            params={{
                                id: selectedPhieu?.id,
                                type: MAP_EXPORT_PATH.PHIEU_CHI_DINH_KHAM_BENH
                            }}
                            keyOpenPhieuIn={keyOpenPhieuIn}
                            setKeyOpenPhieuIn={setKeyOpenPhieuIn}
                            keyBtn={KEY.F1}
                        />
                    )}
                    {selectedPhieu?.id && <ButtonInPhieu
                        label="In phiếu"
                        className="min-w-100px"
                        fetchExport={inPhieuChuyenPK}
                        params={{
                            orderGroupId: selectedPhieu?.id,
                        }}
                    />}
                </div>
            </div>

            <ConfirmDialog
                title="Thông báo"
                yes="Có"
                close="Không"
                message={MESSAGE.CONFIRM.XOA_PHIEU}
                show={openConfirmDialog}
                onYesClick={handleYesClick}
                onCloseClick={() => setOpenConfirmDialog(false)}
            />
        </Row>
    );
};

export default TabCongKham;
